import ApiStore from './ApiStore';
import axios from 'axios';

class PermissionStore extends ApiStore {

  getConfig() {
    return this.wrapResponse(axios.get('/admin/config_sidebar'));
  }

  saveConfig(sidebar_menu) {
    return this.wrapResponse(axios.post('/admin/config_sidebar',{
          sidebar_menu,
        }));
  }
}

export default new PermissionStore();



// WEBPACK FOOTER //
// ./src/stores/PermissionStore.js